export default __webpack_public_path__ + "static/media/kistachool2.cfd1dc0e.jpg";